module.exports = __webpack_public_path__ + "assets/img/replenishmentQuantity.3291704a.png";